import * as React from 'react';
import clsx from 'clsx';
import {
    withRouter,
    Switch,
    RouteComponentProps,
    Route
} from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IState } from 'services/root-reducer';
import { isMobileOnly } from 'react-device-detect';
import { routes } from 'routes';
import { freeSpace } from 'utils';
import { EOperationStatus, IOperation } from 'types';
import { getOperation, getOperationSafe, getOmjsViewInstance, getRoots } from 'selectors';

import { MobileUIAppHeader } from 'mobile-ui/components/app-header';
import { CategorySelectorLite } from 'scenes/side-bar/category-selector-lite';
import { CategoryPanel } from 'scenes/side-bar/category-panel';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { MapZoomControl } from 'scenes/map/controls/zoom-control';
import { categoriesConfig, isCategoryAvailable } from 'scenes/side-bar/categories-config';
import { LinksListUL } from 'scenes/map/controls/links/inks-list';
import { OrientationBlocker } from 'components/orientation-blocker';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import {
    ButtonGroup,
    Button,
    Icons,
    PanelHeader,
    CloseButton,
    PanelBody,
    AutoScrollbars
} from 'components';
import { MobileUIUserMenu } from 'mobile-ui/components/user-menu';
import { ProjectLayer } from 'types/omjs/project';
import { FolderCode } from 'project-constants';
import { MobileUiMap } from './map';
import { MobileUIObjectWindow } from './object-window';
import { MobileUIObjectGenPlanyWindow } from './object-window-gen-plany';
import { BaseLayersListULWrapper } from './base-layers-list-ul-wrapper';
import { MobileUISubmitApplicationWrapper } from './submit-application-wrapper';

import './style.scss';
import { MobileUIComparisonMenuWrapper } from './comparison-menu-wrapper';
import { MobileUIListWindow } from './list-window';
import { MobileUIObjectFiltersWindow } from './object-filters-window';
import { MobileUIFavoritesWindow } from './favorites-window';
import { MobileUIObjectLinkWindowWrapper } from './object-link-window-wrapper';
import { MobileUIFavoritesExportLayerChooser } from './favorites-export-layer-chooser-wrapper';
import { MobileUIObjectDataUpdate } from './object-data-update';
import { MobileUIAuthForm } from './auth-form';
import { DownloadAppSuggestion } from './download-app-suggestion';
import { MobileUICategorySelector } from './category-selector';

export interface IMobileUiRootSceneProps extends RouteComponentProps<{ container: string; }>, WithTranslation {
    projectId: string;
    mapCode: string;
    mapName: string;
    apiHost: string;

    initialize: IOperation | null;
    dataLoad: IOperation | null;
    view: omjs.View;
    publicationSettings: IState['app']['config']['publication'];
}
export interface IMobileUiRootSceneState {
    app_header_search_enabled: boolean;
    is_category_selector_opened: boolean;
    is_help_opened: boolean;
    is_base_layer_switcher_opened: boolean;
    app_search_results_vis: boolean,
    is_menu_opened: boolean;
    selected_category: string;
}

const mapStateToProps = (state: IState) => ({
    initialize: getOperation(state, 'APP_INITIALIZE'),
    dataLoad: getOperationSafe(state, 'DATA_LOAD'),
    view: getOmjsViewInstance(state),
    publicationSettings: state.app.config.publication
});

class MobileUiRootSceneComponent extends React.Component<IMobileUiRootSceneProps, IMobileUiRootSceneState> {
    constructor(props: IMobileUiRootSceneProps) {
        super(props);

        this.state = this.getInitialState();

        this.closeUserMenu = this.closeUserMenu.bind(this);
    }

    getInitialState(): IMobileUiRootSceneState {
        return {
            app_header_search_enabled: false,
            app_search_results_vis: false,
            is_category_selector_opened: false,
            is_help_opened: false,
            is_base_layer_switcher_opened: false,
            is_menu_opened: false,
            selected_category: null
        };
    }

    componentDidMount() {
        document.body.className = clsx(document.body.className, 'mobile-version');
    }

    closeUserMenu() {
        this.setState({
            is_menu_opened: false
        });
    }

    // renderCategorySelector() {
    //     return (
    //         <CategorySelector
    //             onCategoryClick={(category) => {
    //                 this.setState({
    //                     selected_category: category
    //                 });
    //             }}
    //         />
    //     );
    // }

    renderMapControls() {
        let {
            view,
            publicationSettings
        } = this.props;

        if (!this.state.app_header_search_enabled) {
            return (
                <div
                    className="map-controls"
                    ref={el => freeSpace.setElement(el)}
                >
                    <MapZoomControl
                        map={view.getMap()}
                        settings={publicationSettings.map_position}
                        className='mobile-ui-zoom-control'
                    />

                    <ButtonGroup className='mobile-ui-right-controls' orientation='vertical'>
                        {/* <Button
                            variant='black'
                            icon={<Icons.IconQuestionMark />}
                            onClick={() => {
                                this.setState({
                                    is_help_opened: true
                                });
                            }}
                        /> */}
                        <Button
                            variant='black'
                            className='mobile-ui-layer-switcher-button'
                            icon={<Icons.IconLayers />}
                            onClick={() => {
                                this.setState({
                                    is_base_layer_switcher_opened: true
                                });
                            }}
                        />
                    </ButtonGroup>

                    {/* <Button
                        variant='blue'
                        icon={<Icons.IconQuadMenu />}
                        className='mobile-ui-containers-menu-button'
                        onClick={() => {
                            this.setState({
                                is_category_selector_opened: true
                            });
                        }}
                    /> */}
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        let {
            initialize,
            dataLoad,
            match,
            t
        } = this.props;

        if (initialize?.status !== EOperationStatus.SUCCESS) {
            return null;
        }

        return (
            <React.Fragment>
                <Route
                    path='*'
                    render={() => (
                        <OrientationBlocker
                            blockCondition={isMobileOnly}
                            blockOrientation='horizontal'
                            blockText={t('Пожалуйста, поверните ваше устройство вертикально')}
                        />
                    )}
                />
                <Route
                    path="*"
                    render={() => {
                        let { center, zoom, layers } = routes.getCurrentRoute().params;

                        return (
                            <MobileUiMap
                                centerFromUrl={center}
                                zoomFromUrl={zoom}
                                layersFromUrl={layers}
                            />
                        );
                    }}
                />

                {
                    dataLoad.status === EOperationStatus.SUCCESS && (
                        <div className="mobile-ui">

                            {/* <DownloadAppSuggestion /> */}

                            <MobileUIAppHeader
                                onMenuOpen={() => {
                                    this.setState({
                                        is_menu_opened: true
                                    });
                                }}
                                onCategorySelectorOpen={(category) => {
                                    this.setState({
                                        is_category_selector_opened: true,
                                        selected_category: category
                                    });
                                }}
                                searchOpen={this.state.app_header_search_enabled}
                                onToggleSearch={(v: boolean) => this.setState({ app_header_search_enabled: v })}
                                onToggleSearchRes={(v: boolean) => this.setState({ app_search_results_vis: v })}
                                searchResOpen={this.state.app_search_results_vis}
                            />

                            {this.renderMapControls()}

                            <MobileUICategorySelector
                                open={(
                                    this.state.is_category_selector_opened
                                    && isCategoryAvailable(this.state.selected_category)
                                )}
                                currentCategory={this.state.selected_category}
                                onClose={() => {
                                    this.setState({
                                        is_category_selector_opened: false,
                                        selected_category: null
                                    });
                                }}
                                onCategoryClick={(category) => {
                                    this.setState({ selected_category: category });
                                }}
                                onSearchResultClick={() => this.setState({ is_category_selector_opened: false })}
                                searchOpen={this.state.app_header_search_enabled}
                                toggleSearch={(v) => this.setState({ app_header_search_enabled: v })}
                                onToggleSearchRes={(v: boolean) => this.setState({ app_search_results_vis: v })}
                                searchResOpen={this.state.app_search_results_vis}
                            />

                            <SlideUpPanel
                                open={this.state.is_help_opened}
                                className='mobile-ui-help fix-close-button'
                            >
                                <PanelHeader>
                                    <CloseButton
                                        onClick={() => {
                                            this.setState({
                                                is_help_opened: false
                                            });
                                        }}
                                    />
                                </PanelHeader>

                                <PanelBody>
                                    <LinksListUL />
                                </PanelBody>
                            </SlideUpPanel>

                            <SlideUpPanel
                                open={this.state.is_base_layer_switcher_opened}
                                className='mobile-ui-base-layer-switcher fix-close-button'
                            >
                                <PanelHeader>
                                    <CloseButton
                                        onClick={() => {
                                            this.setState({
                                                is_base_layer_switcher_opened: false
                                            });
                                        }}
                                    />
                                </PanelHeader>

                                <PanelBody>
                                    <BaseLayersListULWrapper />
                                </PanelBody>
                            </SlideUpPanel>

                            <MobileUIUserMenu
                                open={this.state.is_menu_opened}
                                onClose={() => {
                                    this.setState({
                                        is_menu_opened: false
                                    });
                                }}
                                onLoginClick={this.closeUserMenu}
                                onLogoutClick={this.closeUserMenu}
                                onFavClick={() => {
                                    this.setState({
                                        is_menu_opened: false
                                    });
                                    routes.redirect(routes.favourites);
                                }}
                                onApplianceClick={() => {
                                    this.setState({
                                        is_menu_opened: false
                                    });
                                    overlayWindowsActions.showApplicationOverlay({
                                        objects: []
                                    });
                                }}
                            />
                            <MobileUISubmitApplicationWrapper />
                            <MobileUIObjectFiltersWindow />
                            <MobileUIObjectLinkWindowWrapper />
                            <MobileUIFavoritesExportLayerChooser />
                            <MobileUIObjectDataUpdate />
                            <MobileUIAuthForm />

                            <Switch>
                                {/**
                                 * Эта строка фиксит закрытие окна по объекту.
                                 * При закрытии окна пользвателя переадресовывает по адресу /map/root
                                 * Если урла routes.map не будет ловить такую урлу, то ее будет ловить routes.objectShort,
                                 * который попытается опять открыть окно по слою `map` и id слоя `root` и все упадет
                                */}
                                <Route {...routes.map} render={() => null} />
                                <Route {...routes.favourites} render={() => <MobileUIFavoritesWindow />} />
                                <Route
                                    {...routes.list}
                                    render={({ match: route_match }) => (
                                        <MobileUIListWindow
                                            layerCode={route_match.params.layerCode}
                                        />
                                    )}
                                />
                                <Route
                                    {...routes.object}
                                    render={({ match: route_match }) => {
                                        if (route_match.params.layerCode === FolderCode['GEN_PLANS_OBJECTS']) {
                                            return (
                                                <MobileUIObjectGenPlanyWindow
                                                    onZoomToObject={() => {
                                                        this.setState(this.getInitialState());
                                                    }}
                                                />
                                            );
                                        } else {
                                            return (
                                                <MobileUIObjectWindow
                                                    onZoomToObject={() => {
                                                        this.setState(this.getInitialState());
                                                    }}
                                                />
                                            );
                                        }
                                    }}
                                />
                                <Route
                                    {...routes.objectShort}
                                    render={({ match: route_match }) => {
                                        if (route_match.params.layerCode === FolderCode['GEN_PLANS_OBJECTS']) {
                                            return (
                                                <MobileUIObjectGenPlanyWindow
                                                    onZoomToObject={() => {
                                                        this.setState(this.getInitialState());
                                                    }}
                                                />
                                            );
                                        } else {
                                            return (
                                                <MobileUIObjectWindow
                                                    onZoomToObject={() => {
                                                        this.setState(this.getInitialState());
                                                    }}
                                                />
                                            );
                                        }
                                    }}
                                />
                            </Switch>
                        </div>
                    )
                }
            </React.Fragment>
        );
    }
}

export const MobileUiRootScene = connect(mapStateToProps)(withRouter(withTranslation()(MobileUiRootSceneComponent)));
